import TweetsMarquee, { type TweetProps } from '@/common/TweetsMarquee';
import type { CustomersReviewsProps } from '@/components/shared';
import { Section, SectionParagraph as Subtitle, SectionTitle as Title } from '@/components/shared/Content';
import Hearts from '@/static/assets/dating/hearts.svg';
import Annabelle from '@/static/assets/dating/tweets/Annabelle.png';
import Ben from '@/static/assets/dating/tweets/Ben.png';
import Callie from '@/static/assets/dating/tweets/Callie.png';
import Jake from '@/static/assets/dating/tweets/Jake.png';
import Janice from '@/static/assets/dating/tweets/Janice.png';
import Matt from '@/static/assets/dating/tweets/Matt.png';
import Sabrina from '@/static/assets/dating/tweets/Sabrina.png';
import { Flex } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import styled from 'styled-components';

export const TWEETS: TweetProps[] = [
  {
    name: 'Matt Y',
    img: Matt.src,
    handle: '@Mattyboy7',
    text: '<span class="primary">@Lemonade_Inc</span> Went on a date for the first time since my breakup. They talked about their ex for 3 hours and pronounced my name wrong like 5 times. Luckily I have Lemonade Dating insurance. Got reimbursed for everything!',
  },
  {
    name: 'Ben Samson',
    img: Ben.src,
    handle: '@Bensamson472',
    text: 'Um, I think I’m done with dating apps. This city is too small. Pretty sure I just went on a date with my third cousin. So thankful I have <span class="primary">@Lemonade_Inc</span> Dating Insurance. Got paid back for my entire night! Next family reunion is gonna be awkward.',
  },
  {
    name: 'Sabrina L',
    img: Sabrina.src,
    handle: '@SabbyCat',
    text: 'Just went on the worst date of MY LIFE. He was a magician. He literally pulled a dove out of his pocket at one point, and when the check came, he disappeared. Filed a claim with <span class="primary">@Lemonade_Inc</span> on my cab ride home, and got paid within seconds.',
  },
  {
    name: 'Annabelle K',
    img: Annabelle.src,
    handle: '@foreveralon3',
    text: 'He works at an insurance company…',
  },
  {
    name: 'Callie P',
    img: Callie.src,
    handle: '@Callmecallie',
    text: 'Third time this month I got ghosted. Showed up to the bar. My date never came. Drank 7 vodka martinis. Cried to the bartender. I don’t think I can ever go back to that bar, but at least Lemonade reimbursed me for the night. ',
  },
  {
    name: 'Jake B',
    img: Jake.src,
    handle: '@justjake',
    text: 'Just watched my date take 18 photos of his meal. It was soup. Can’t get the time back, but at least <span class="primary">@Lemonade_Inc</span> got my money back.',
  },
  {
    name: 'Janice',
    img: Janice.src,
    handle: '@jjjjanice',
    text: 'His profile said he was 32. He wasn’t even 42! He was 49. Told me he needs to “update his profile”. Never been more thankful to have <span class="primary">@Lemonade_Inc</span>',
  },
];

const StyledTitle = styled(Title)`
  text-align: center;
`;

const StyledSubtitle = styled(Subtitle)`
  text-align: center;
  margin: 20px 0;
  ${MEDIA_QUERIES.desktop`
        margin-bottom: 55px;
    `}
`;

const CustomSection = styled(Section)`
  background-image: linear-gradient(rgb(247, 247, 247) 80%, rgba(255, 255, 255, 0.5) 100%);
`;

const HeartsImg = styled.img`
  pointer-events: none;
  object-fit: cover;
  width: 100%;
  max-width: 748px;
  margin-bottom: 55px;
`;

export const Reviews = ({ title, subtitle }: CustomersReviewsProps) => {
  return (
    <CustomSection py={[60, 96]} px={20}>
      <Flex width="100%" alignItems="center" flexDirection="column">
        <StyledTitle>{title}</StyledTitle>
        <StyledSubtitle>{subtitle}</StyledSubtitle>
        <HeartsImg src={Hearts.src} alt="" />
        <TweetsMarquee tweets={TWEETS} />
      </Flex>
    </CustomSection>
  );
};
